var MapOptions = /** @class */ (function () {
    function MapOptions() {
    }
    return MapOptions;
}());
export { MapOptions };
//# sourceMappingURL=map-options.js.map